function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.03 59.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.65.69c-.38.38-2.96.72-5.75.75-5.03.06-5.07.09-8.45,5.56-2.53,4.09-3.67,7.42-4.45,13-.58,4.12-2.16,10.73-3.52,14.67-3,8.7-3.31,17.28-.72,19.56,3.59,3.15,8.18,4.76,12.94,4.56,2.64-.11,6.04.16,7.53.61,2.28.68,3.21.32,5.75-2.21,3.71-3.72,4.01-8.84,1.05-18.34-1.59-5.1-1.87-8.09-1.43-15.34.3-4.95,1.01-11.15,1.58-13.77,1.27-5.83.46-9.73-2.02-9.73-1,0-2.13.31-2.51.69",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.06,11.13l-2.05,3.37v-3.53c0-1.94.78-4.64,1.74-6l1.75-2.47.3,2.63c.17,1.45-.62,4.15-1.75,6",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25,12.4c-.5,2.25-.88,8.49-.83,13.85l.08,9.75h-9.17c-5.04,0-9.91.29-10.82.64-1.53.59-1.53.35-.04-3.22.89-2.12,2.08-7.22,2.65-11.33.99-7.12,2.9-12.18,6.24-16.58,1.4-1.83,1.5-1.34,1.2,6-.18,4.4-.66,10.7-1.08,14-.42,3.3-.47,5.73-.11,5.4.36-.33,1.91-4.16,3.43-8.5,1.53-4.34,3.54-9.04,4.46-10.44.93-1.4,2.25-4.1,2.95-6l1.27-3.46.33,2.9c.18,1.59-.08,4.74-.58,7",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75,39.46c1.15.89,2.04,10.99,1.17,13.27-1.43,3.77-2.05,3.99-10.37,3.7-10.04-.35-15.55-3.35-15.55-8.47,0-6.16,1.12-8.85,3.86-9.22,2.42-.33,20.32.28,20.88.72",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg27);
export default __webpack_public_path__ + "static/media/27.fdb3ca47c97fdf08e4db114535cd18d7.svg";
export { ForwardRef as ReactComponent };